// Mismas reglas que valida el backend antes de llamar a Flow (nombre ≤ 120, correo ≤ 254 con "@").
// Devuelve un objeto de mensajes por campo; vacío significa que todo está bien.
const FORMATO_CORREO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validarDatosPersona({ name = '', email = '' } = {}) {
  const errores = {};
  const nombre = String(name).trim();
  if (nombre.length < 2) errores.name = 'Escribe tu nombre.';
  else if (nombre.length > 120) errores.name = 'El nombre es demasiado largo.';

  const correo = String(email).trim();
  if (!FORMATO_CORREO.test(correo) || correo.length > 254) errores.email = 'Escribe un correo válido.';
  return errores;
}
